var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{staticClass:"mt-base",attrs:{"title":"Photo"}},[_c('list-thumb-view',{attrs:{"listing-id":_vm.listingId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }